var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z",
    fill: "#00A0FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1357 15.502C9.94592 15.5025 9.76299 15.431 9.62379 15.302L6.14185 12.05C6.06963 11.9828 6.01125 11.9021 5.97022 11.8124C5.9292 11.7227 5.90641 11.6258 5.90284 11.5272C5.89926 11.4286 5.91505 11.3303 5.94947 11.2379C5.98389 11.1455 6.03611 11.0607 6.10328 10.9884C6.17045 10.9162 6.25113 10.858 6.34083 10.8169C6.43053 10.7759 6.52741 10.7529 6.62598 10.7494C6.72455 10.7458 6.8231 10.7617 6.91553 10.7961C7.00797 10.8305 7.09258 10.8828 7.1648 10.95L10.0938 13.685L15.7468 7.51395C15.8128 7.43948 15.893 7.37891 15.9827 7.33573C16.0723 7.29256 16.1697 7.26766 16.2691 7.26249C16.3684 7.25732 16.4679 7.27195 16.5615 7.30558C16.6552 7.33922 16.7413 7.3912 16.8147 7.45841C16.8881 7.52563 16.9473 7.60677 16.989 7.69712C17.0307 7.78748 17.0541 7.8852 17.0576 7.98466C17.0612 8.08411 17.0449 8.1833 17.0098 8.27641C16.9746 8.36951 16.9212 8.45467 16.8528 8.52695L10.6887 15.257C10.6216 15.3299 10.5409 15.3887 10.4509 15.4302C10.361 15.4717 10.2638 15.4951 10.1648 15.4989L10.1357 15.502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateCheckCircle);
export default __webpack_public_path__ + "static/media/activateCheckCircle.18574283eafad51d3102d47319640d58.svg";
export { ForwardRef as ReactComponent };